module.exports = __webpack_public_path__ + "d0924cebd0659ea6e26c77ff8ca76088.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-320.webp
// module id = 508
// module chunks = 0